import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import moment from 'moment';

const grayMarker = '/img/icons/destacado.svg';
const mintMarker = '/img/icons/bandera-mint.svg';
const mintCircle = '/img/icons/mono-verde.svg';
const grayCircle = '/img/icons/mono-gray.svg';

const styledBy = (property, mapping) => props => mapping[props[property]];

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginBottom: 16,
  },
  name: {
    width: '100%',
    fontSize: 16,
    fontWeight: 'bold',
    margin: '16px 0 0',
    paddingRight: 42,
    maxWidth: 476,
    color: '#10587f',
    lineHeight: 'normal',
  },
  textMsg: {
    padding: '0 16px',
    marginTop: 9,
  },
}));

const ExpansionPanel = withStyles({
  root: {
    boxShadow: 'none',
    color: '#484848',
    marginBottom: 10,
    borderRadius: 4,
    border: styledBy('color', {
      default: '1px solid #e7e7e7',
      mint: '1px solid transparent',
    }),
    backgroundColor: styledBy('color', {
      default: 'white',
      mint: 'rgba(53, 185, 182, 0.08)',
    }),
    '&$expanded': {
      backgroundColor: 'rgba(53, 185, 182, 0.08)',
      color: '#013957',
    },
  },
  expanded: {},
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    padding: '0 16px',
    minHeight: 56,
    position: 'relative',
    '@media screen and (max-width: 1017px)': {
      minHeight: 'unset',
    },
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    margin: '0 0 15px',
    width: '100%',
    '&$expanded': {
      margin: 0,
    },
  },
  expandIcon: {
    color: '#c1c1c1',
    alignSelf: 'flex-end',
    position: 'absolute',
    right: 16,
  },
  expanded: {},
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles({
  root: {
    color: '#484848',
    paddingTop: 0,
    display: 'block',
  },
})(MuiExpansionPanelDetails);


export default  function Message(props) {
  const classes = useStyles();
  const { expanded, onChange, message ,handleSave, handleClickDelete } = props;
  const [saved, setSaved] = useState(message.save);

  let color = message.read ?   'default':'mint';
  moment.locale('es');
  const dateMsg = message.createdAt._seconds ? moment.unix(message.createdAt._seconds, 'DD-MM-YYYY HH:mm ').fromNow() : '' ;

  

  const saveContact = () => {

    setSaved(true)

  }

  


  return (
    <div className={classes.root}>
      <ExpansionPanel expanded={expanded} onChange={onChange} color={color}>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
          className="message-summary"
        >
          <img
            src={message.clientUid? mintCircle:grayCircle}
            style={{
              width: 16,
              height: 16,
              margin: '18px 8px 0 0',
            }}
            alt={message.clientUid? "usuario registrado":"usuario no registrado"}
          />

          <div
            className={
              saved && !expanded ? 'savedContact' : 'savedContact-hidden'
            }
          >
            <img src={saved ? mintMarker : grayMarker} alt="contacto guardado" />
          </div>

          <div style={{ width: '90%' }}>
            <Typography className={classes.name}>{message.name}</Typography>
            
            <small className="message-date">{dateMsg}</small>
            {expanded ? (
              <div className="message-sm-hidden">{message.text}</div>
            ) : (
              <div className="message-sm">{message.text}</div>
            )}
          </div>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography className={classes.textMsg}>{message.text}</Typography>

          <div className="contactInfo">
            <div
              className="contactInfo-save"
              onClick={() => {
                handleSave(message)
                saveContact()}}
            >
              <img
                src={saved && saved ? mintMarker : grayMarker}
                alt="Guardar contacto"
              />
            </div>
            <h4 className="contactInfo-text contactInfo-blue">
              Datos de contacto del usuario
            </h4>
            <div className="contactInfo-details">
              <div className="contactInfo-phone">
               {/*  <p className="contactInfo-text contactInfo-bold city">
                  Localidad:
                  <span className="contactInfo-text"> {message.localidad}</span>
                </p> */}
                <p className="contactInfo-text contactInfo-bold">
                  Teléfono:
                  <span className="contactInfo-text"> {message.phone}</span>
                </p>
              </div>
              <div>
                <p className="contactInfo-text contactInfo-bold">
                  Correo:
                  <span className="contactInfo-text"> {message.email}</span>
                </p>
              </div>
            </div>
          </div>

          <div className="deleteMsg">
            <button onClick={() => handleClickDelete(message)}>Eliminar mensaje</button>
          </div> 
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  );
}


/* const mapDispatchToProps = dispatch => ({
    deleteLawyerMessage: (uid, item, allLayers) =>
    dispatch(deleteLawyerMessage(uid, item, allLayers)),
}); */
/* 
export default connect(null, mapDispatchToProps)(Message); */